module.exports = __webpack_public_path__ + "media/bootstrap-icons/compass-fill-f0c58937.svg";